import axios from './axios.js'

export const getClientsRequest = () => axios.get('/users')

export const getClientRequest = (username) => axios.get(`/users/${username}`)

export const createClientRequest = (client) => axios.post('/users', client)

export const deleteClientRequest = (username) => axios.delete(`/users/${username}`)

export const updateUsernameClientRequest = (username, newUsername) => axios.put(`/users/username/${username}`, newUsername)

export const updateEmailClientRequest = (username, email) => axios.put(`/users/email/${username}`, email)

export const updatePasswordClientRequest = (username, password) => axios.put(`/users/password/${username}`, password)

export const updateSheetClientRequest = (username, sheet) => axios.put(`/users/sheet/${username}`, sheet)

export const updatePluginClientRequest = (username, plugin) => axios.put(`/users/plugin/${username}`, plugin)

export const updateActiveClientRequest = (username) => axios.put(`/users/active/${username}`)

export const updateExpirationClientRequest = (username, expiration) => axios.put(`/users/expiration/${username}`, expiration)